import type { DiagnosticKeywordCompetitorsDto, DiagnosticKeywordDto } from '@malou-io/package-dto';
import type { MaloupeLocale } from '@malou-io/package-utils';

export class DiagnosticKeyword {
    keyword: {
        [MaloupeLocale.FR]: string;
        [MaloupeLocale.EN]?: string | null;
    };
    googlePosition: number;
    competitorsGooglePositions: DiagnosticKeywordCompetitorsDto[];

    constructor({ keyword, googlePosition, competitorsGooglePositions }: DiagnosticKeyword | DiagnosticKeywordDto) {
        this.keyword = keyword;
        this.googlePosition = googlePosition;
        this.competitorsGooglePositions = competitorsGooglePositions;
    }
}
